// @ts-nocheck


import React, { useState, useCallback } from 'react';

import { goBack } from '../../lib/helpers';
import { stockApi } from '../../lib/api';


import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';





const entryPointPath = '/admin/stock/';

export default (props) => {
  const [data, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, data.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await stockApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload) => {
    let id = payload.id;
    if (id) {
      await stockApi.update(payload);
    } else {
      await stockApi.add(payload);
    }
    await goBack(`${entryPointPath}`);
  };

  const onCancel = async (payload) => {
    await goBack(`${entryPointPath}`);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Склады'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}>

      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>);

};
